<template>
  <div class="user-level-log">
    <el-card shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>等级变动日志</span>
        </div>
      </template>

      <el-table
        :data="logs"
        style="width: 100%"
        border
        header-align="center"
        align="center"
      >
        <el-table-column prop="user_id" label="用户ID" min-width="180" />
        <el-table-column prop="nickname" label="昵称" min-width="140" />
        <el-table-column prop="from_level" label="原等级" min-width="90" />
        <el-table-column prop="to_level" label="新等级" min-width="90" />
        <el-table-column prop="change_type" label="类型" min-width="120" />
        <el-table-column prop="reason" label="原因" min-width="240" />
        <el-table-column prop="operator" label="操作人" min-width="120" />
        <el-table-column prop="created_at" label="时间" min-width="180" />
      </el-table>

      <div v-if="!logs.length" style="padding: 16px; color: #909399;">
        当前没有日志
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'UserLevelLog',
  data() {
    return {
      logs: []
    }
  },
  mounted() {
    this.loadLogs()
  }
  ,
  methods: {
    async loadLogs() {
      try {
        const resp = await this.$api.get('/admin/user-level-log')
        if (resp && resp.code === 200) {
          this.logs = resp.data || []
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          '获取日志失败'
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>

